/**
 * The MedicAI Support user's id. A dependency-free module so pure helpers (`task-assignees.ts`) and their
 * specs can import it without pulling in `SupportService` and, through it, the environment files.
 * `support.service.ts` re-exports it, so its existing importers are unchanged.
 */
export const SUPPORT_USER_ID = '511f39e1-ff14-4a6d-b35a-6fcc22923b50';
